import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Box, Toolbar, useMediaQuery } from '@mui/material';
import { openDrawer } from 'store/reducers/menu';
import { MenuState, Store } from 'store/types';

// project import
import Drawer from './Drawer';
import Header from './Header';
import NetworkConnectionAlert from '../../components/NetworkConnectionAlert';
import SearchTypeSetter from './SearchTypeSetter';
import ScrollContextComponent from '../../contexts/ScrollContext';
import CmsFileDialogs from '../../components/cms/CmsFileDialogs';

import './Main.layout.css';

// ==============================|| MAIN LAYOUT ||============================== //

function isExpanded(path: string): boolean {
    const regex = new RegExp(/^\/cms\/pages\/.*\/(edit|new)\/.{5}$/g);
    return !regex.test(path);
}

type ThemeStylesProps = {
    mode: 'light' | 'dark';
};
const ThemeStyles = ({ mode }: ThemeStylesProps) => {
    const light = '#b6b6b6';
    const dark = '#313131';
    return (
        <style>
            {' * {' +
                '    scrollbar-width: auto;' +
                `    scrollbar-color: ${mode === 'dark' ? dark : light} transparent !important;` +
                '}' +
                '*::-webkit-scrollbar-thumb {' +
                `    background-color: ${mode === 'dark' ? dark : light};` +
                '    border-radius: 10px;' +
                '    border: none;' +
                '}'}
        </style>
    );
};

const MainLayout = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const { pathname } = useLocation();

    const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
    const { drawerOpen } = useSelector<Store, MenuState>(state => state.menu);

    // drawer toggler
    const [open, setOpen] = useState(drawerOpen);

    const handleDrawerToggle = () => {
        dispatch(openDrawer({ drawerOpen: !open }));
    };
  // set media wise responsive drawer
  useEffect(() => {
    if (!isExpanded(pathname) || matchDownLG) {
      dispatch(openDrawer({ drawerOpen: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG, pathname]);


    useEffect(() => {
        if (open !== drawerOpen) setOpen(drawerOpen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen]);

    return (
        <>
            <SearchTypeSetter />
            <ThemeStyles mode={theme.palette.mode} />
            <Box
                className={`theme-${theme.palette.mode}`}
                sx={{ display: 'flex', width: '100%', height: '100%' }}>
                <Header open={open} handleDrawerToggle={handleDrawerToggle} />
                <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
                <ScrollContextComponent
                    sx={{
                        width: '100%',
                        flexGrow: 1,
                        position: 'relative',
                        height: '100%',
                        overflowY: 'scroll',
                    }}>
                    <Toolbar />
                    <NetworkConnectionAlert />
                    <Outlet />
                </ScrollContextComponent>
                <CmsFileDialogs />
            </Box>
        </>
    );
};

export default MainLayout;
